module.exports = __webpack_public_path__ + "static/ppp-sales-page-image-videotutorial.d9998414.jpg";